<div mat-dialog-title>
  <div class="dialog-caption">Custom {{ categoryLabel }} Categories</div>
  <div class="dialog-subtitle">
    {{ category ? 'Add or edit custom categories for Plant & Equipment depreciation if your cant find the right ATO category in our list.' : 'Add or edit new personal categories and customise your expense budget' }}
  </div>
  <button mat-dialog-close class="btn icon-close"></button>
</div>

<div mat-dialog-content>
  <app-chart-accounts-form [category]="category" [categoryLabel]="categoryLabel"></app-chart-accounts-form>
</div>

<div mat-dialog-actions></div>
